import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project-imports
import Logo from 'components/logo';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

export default function Footer() {
  return (
    <Stack direction={{ sm: 'row' }} sx={{ gap: 1, justifyContent: 'space-between', alignItems: 'center', pt: 3, mt: 'auto' }}>
      <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center', flexWrap: 'wrap' }}>
        <Logo
          to="/dashboard"
          sx={{
            display: 'flex',
            alignItems: 'center',
            maxWidth: 140
          }}
        />
        <Typography variant="caption">
          Powered by{' '}
          <Link href="https://bftgroup.com/" target="_blank" underline="none">
            BFT Group
          </Link>
          .
        </Typography>
      </Stack>
      <Stack direction="row" sx={{ gap: 1.5, justifyContent: 'space-between', alignItems: 'center' }}>
        <Link component={RouterLink} to="https://bftgroup.co" target="_blank" variant="caption" color="text.primary">
          Home
        </Link>
      </Stack>
    </Stack>
  );
}
